import { Inject, Injectable } from '@angular/core';

import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { Observable, of } from 'rxjs';

import { IBetslipMessages } from '../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { CriteriaType } from '../../../../reward-tokens/reward-tokens.model';
import { BetslipError } from '../../../errors/betslip-error';
import { RewardTokensTradingEntityMismatchError } from '../../../errors/general/reward-tokens-trading-entity-mismatch-error';
import { IExtendedMessage, MessageFormatter } from './message-formatter';

@Injectable()
export class RewardTokensTradingEntityMismatchMessageFormatter extends MessageFormatter<RewardTokensTradingEntityMismatchError> {
    private messages: IBetslipMessages;
    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
        private stringInterpolationPipe: StringInterpolationPipe,
    ) {
        super();
        this.messages = messageProvider.getMessages();
    }

    format(error: RewardTokensTradingEntityMismatchError): Observable<string | IExtendedMessage> {
        let entityName = '';
        if (error.entityNames.length > 1) {
            switch (error.criteriaType) {
                case CriteriaType.Sports:
                    entityName = this.messages.crmTokens.errors.TradingEntityTypeSports;
                    break;
                case CriteriaType.Competitions:
                    entityName = this.messages.crmTokens.errors.TradingEntityTypeCompetitions;
                    break;
                case CriteriaType.Meetings:
                    entityName = this.messages.crmTokens.errors.TradingEntityTypeMeetings;
                    break;
                case CriteriaType.Fixtures:
                    entityName = this.messages.crmTokens.errors.TradingEntityTypeFixtures;
                    break;
                case CriteriaType.OptionId:
                    entityName = this.messages.crmTokens.errors.TradingEntityTypeOptions;
                    break;
                case CriteriaType.TemplateId:
                    entityName = this.messages.crmTokens.errors.TradingEntityTypeTemplates;
                    break;
                case CriteriaType.MarketId:
                    entityName = this.messages.crmTokens.errors.TradingEntityTypeMarkets;
                    break;
                case CriteriaType.MarketParameter:
                    entityName = this.messages.crmTokens.errors.TradingEntityTypeV2Parameters;
                    break;
            }
        } else {
            entityName = error.entityNames[0].name;
        }

        const template = this.messages.crmTokens.errors.CriteriaNotMet;

        return of(this.stringInterpolationPipe.transform(template, { criteria: entityName }));
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof RewardTokensTradingEntityMismatchError;
    }
}
